// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

const isInMailingList = async ({
    test,
    email,
}: {
    test: boolean,
    email: string,
}): Promise<boolean> => {
    const functions = getFunctions();
    const handleIsInMailingList = httpsCallable<
        Record<
            string,
            boolean | string
        >,
        boolean
    >(
        functions,
        'isInMailingList',
    );
    return handleIsInMailingList({
        test,
        email,
    }).then((result) => {
        const emailInMailingList = result.data as boolean;
        return emailInMailingList;
    }).catch((err) => {
        throw err;
    });
};

export default isInMailingList;
